import {Injectable} from '@angular/core';
import {
  BasePageMetaResolver,
  PageLinkService,
  PageRobotsMeta,
  ProductPageMetaResolver,
  ProductService,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import {Observable, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {Product} from '@spartacus/core/src/model/product.model';
import {DcpProductUtilitiesService} from '@app/product/services/dcp-product-utilities.service';

const PDP_TARGET_URL_NAME_FEATURE: string = 'PDP target URL';

@Injectable({
  providedIn: 'root'
})
export class DcpProductPageMetaResolver extends ProductPageMetaResolver {

  constructor(routingService: RoutingService, productService: ProductService, translationService: TranslationService, basePageMetaResolver: BasePageMetaResolver, pageLinkService: PageLinkService, private productUtilitiesService: DcpProductUtilitiesService) {
    super(routingService, productService, translationService, basePageMetaResolver, pageLinkService);
  };

  resolveDescription(): Observable<string> {
    return this.product$.pipe(
      switchMap((product: Product) =>
        this.translation.translate('pageMetaResolver.product.description', {
          description: this.getClassificationAttr(product, 'details', 'tinydescription', product.summary)
        })
      ));
  }

  resolveTitle(): Observable<string> {
    return this.product$.pipe(
      switchMap((product) => {
        let title = product.name;
        title += this.resolveManufacturer(product);
        return this.translation.translate('pageMetaResolver.product.title', {
          title,
        });
      })
    );
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.product$.pipe(
      switchMap((product) => {
        let targetUrl = this.productUtilitiesService.getFeatureForProduct(product, PDP_TARGET_URL_NAME_FEATURE);
        let excludedFromSearch = this.productUtilitiesService.isExcludedFromSearch(product);

        if (targetUrl || excludedFromSearch) {
          return of([PageRobotsMeta.NOINDEX, PageRobotsMeta.NOFOLLOW])
        }

        return super.resolveRobots();
      })
    )
  }

  protected resolveManufacturer(product: Product): string {
    return product.vendor?.name ? ` | ${product.vendor.name}` : '';
  }


  /**
   * Extract product's classification attribute inherited from classification class
   * If attribute is not present on product, then fallbackValue is returned
   */
  private getClassificationAttr(product: Product, classificationClass: string, attributeName: string, fallbackValue: string): string {
    const attrFeature = product.classifications?.find(e => e.code === classificationClass)?.features?.find(feature => feature.code.endsWith(attributeName));
    const attrFeatureValue = attrFeature?.featureValues[0]?.value;
    return attrFeatureValue ? attrFeatureValue : fallbackValue;
  }
}
